export class Deferred<T> {
    promise: Promise<T>;
    resolve;
    reject;
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
